export default __webpack_public_path__ + "static/media/antp_ingvehicular_JulioOlivares.bcf62d8e.jpg";